/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as PartsRouteImport } from './routes/parts'
import { Route as KnowledgeRouteImport } from './routes/knowledge'
import { Route as IntegrationRouteImport } from './routes/integration'
import { Route as InsightsRouteImport } from './routes/insights'
import { Route as HubRouteImport } from './routes/hub'
import { Route as HelpRouteImport } from './routes/help'
import { Route as CopilotRouteImport } from './routes/copilot'
import { Route as ChangesRouteImport } from './routes/changes'
import { Route as BomRouteImport } from './routes/bom'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PartsIndexRouteImport } from './routes/parts.index'
import { Route as KnowledgeIndexRouteImport } from './routes/knowledge.index'
import { Route as ChangesIndexRouteImport } from './routes/changes.index'
import { Route as BomIndexRouteImport } from './routes/bom.index'
import { Route as PartsPartNumberRouteImport } from './routes/parts.$partNumber'
import { Route as KnowledgeKbIdRouteImport } from './routes/knowledge.$kbId'
import { Route as ChangesChangeNumberRouteImport } from './routes/changes.$changeNumber'
import { Route as BomAssemblyPartNumberRouteImport } from './routes/bom.$assemblyPartNumber'
import { Route as BomCompareBomIdRouteImport } from './routes/bom.compare.$bomId'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PartsRoute = PartsRouteImport.update({
  id: '/parts',
  path: '/parts',
  getParentRoute: () => rootRouteImport,
} as any)
const KnowledgeRoute = KnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationRoute = IntegrationRouteImport.update({
  id: '/integration',
  path: '/integration',
  getParentRoute: () => rootRouteImport,
} as any)
const InsightsRoute = InsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => rootRouteImport,
} as any)
const HubRoute = HubRouteImport.update({
  id: '/hub',
  path: '/hub',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any)
const CopilotRoute = CopilotRouteImport.update({
  id: '/copilot',
  path: '/copilot',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangesRoute = ChangesRouteImport.update({
  id: '/changes',
  path: '/changes',
  getParentRoute: () => rootRouteImport,
} as any)
const BomRoute = BomRouteImport.update({
  id: '/bom',
  path: '/bom',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PartsIndexRoute = PartsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PartsRoute,
} as any)
const KnowledgeIndexRoute = KnowledgeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => KnowledgeRoute,
} as any)
const ChangesIndexRoute = ChangesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChangesRoute,
} as any)
const BomIndexRoute = BomIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BomRoute,
} as any)
const PartsPartNumberRoute = PartsPartNumberRouteImport.update({
  id: '/$partNumber',
  path: '/$partNumber',
  getParentRoute: () => PartsRoute,
} as any)
const KnowledgeKbIdRoute = KnowledgeKbIdRouteImport.update({
  id: '/$kbId',
  path: '/$kbId',
  getParentRoute: () => KnowledgeRoute,
} as any)
const ChangesChangeNumberRoute = ChangesChangeNumberRouteImport.update({
  id: '/$changeNumber',
  path: '/$changeNumber',
  getParentRoute: () => ChangesRoute,
} as any)
const BomAssemblyPartNumberRoute = BomAssemblyPartNumberRouteImport.update({
  id: '/$assemblyPartNumber',
  path: '/$assemblyPartNumber',
  getParentRoute: () => BomRoute,
} as any)
const BomCompareBomIdRoute = BomCompareBomIdRouteImport.update({
  id: '/compare/$bomId',
  path: '/compare/$bomId',
  getParentRoute: () => BomRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/bom': typeof BomRouteWithChildren
  '/changes': typeof ChangesRouteWithChildren
  '/copilot': typeof CopilotRoute
  '/help': typeof HelpRoute
  '/hub': typeof HubRoute
  '/insights': typeof InsightsRoute
  '/integration': typeof IntegrationRoute
  '/knowledge': typeof KnowledgeRouteWithChildren
  '/parts': typeof PartsRouteWithChildren
  '/settings': typeof SettingsRoute
  '/bom/$assemblyPartNumber': typeof BomAssemblyPartNumberRoute
  '/changes/$changeNumber': typeof ChangesChangeNumberRoute
  '/knowledge/$kbId': typeof KnowledgeKbIdRoute
  '/parts/$partNumber': typeof PartsPartNumberRoute
  '/bom/': typeof BomIndexRoute
  '/changes/': typeof ChangesIndexRoute
  '/knowledge/': typeof KnowledgeIndexRoute
  '/parts/': typeof PartsIndexRoute
  '/bom/compare/$bomId': typeof BomCompareBomIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/copilot': typeof CopilotRoute
  '/help': typeof HelpRoute
  '/hub': typeof HubRoute
  '/insights': typeof InsightsRoute
  '/integration': typeof IntegrationRoute
  '/settings': typeof SettingsRoute
  '/bom/$assemblyPartNumber': typeof BomAssemblyPartNumberRoute
  '/changes/$changeNumber': typeof ChangesChangeNumberRoute
  '/knowledge/$kbId': typeof KnowledgeKbIdRoute
  '/parts/$partNumber': typeof PartsPartNumberRoute
  '/bom': typeof BomIndexRoute
  '/changes': typeof ChangesIndexRoute
  '/knowledge': typeof KnowledgeIndexRoute
  '/parts': typeof PartsIndexRoute
  '/bom/compare/$bomId': typeof BomCompareBomIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/bom': typeof BomRouteWithChildren
  '/changes': typeof ChangesRouteWithChildren
  '/copilot': typeof CopilotRoute
  '/help': typeof HelpRoute
  '/hub': typeof HubRoute
  '/insights': typeof InsightsRoute
  '/integration': typeof IntegrationRoute
  '/knowledge': typeof KnowledgeRouteWithChildren
  '/parts': typeof PartsRouteWithChildren
  '/settings': typeof SettingsRoute
  '/bom/$assemblyPartNumber': typeof BomAssemblyPartNumberRoute
  '/changes/$changeNumber': typeof ChangesChangeNumberRoute
  '/knowledge/$kbId': typeof KnowledgeKbIdRoute
  '/parts/$partNumber': typeof PartsPartNumberRoute
  '/bom/': typeof BomIndexRoute
  '/changes/': typeof ChangesIndexRoute
  '/knowledge/': typeof KnowledgeIndexRoute
  '/parts/': typeof PartsIndexRoute
  '/bom/compare/$bomId': typeof BomCompareBomIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audit'
    | '/bom'
    | '/changes'
    | '/copilot'
    | '/help'
    | '/hub'
    | '/insights'
    | '/integration'
    | '/knowledge'
    | '/parts'
    | '/settings'
    | '/bom/$assemblyPartNumber'
    | '/changes/$changeNumber'
    | '/knowledge/$kbId'
    | '/parts/$partNumber'
    | '/bom/'
    | '/changes/'
    | '/knowledge/'
    | '/parts/'
    | '/bom/compare/$bomId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/audit'
    | '/copilot'
    | '/help'
    | '/hub'
    | '/insights'
    | '/integration'
    | '/settings'
    | '/bom/$assemblyPartNumber'
    | '/changes/$changeNumber'
    | '/knowledge/$kbId'
    | '/parts/$partNumber'
    | '/bom'
    | '/changes'
    | '/knowledge'
    | '/parts'
    | '/bom/compare/$bomId'
  id:
    | '__root__'
    | '/'
    | '/audit'
    | '/bom'
    | '/changes'
    | '/copilot'
    | '/help'
    | '/hub'
    | '/insights'
    | '/integration'
    | '/knowledge'
    | '/parts'
    | '/settings'
    | '/bom/$assemblyPartNumber'
    | '/changes/$changeNumber'
    | '/knowledge/$kbId'
    | '/parts/$partNumber'
    | '/bom/'
    | '/changes/'
    | '/knowledge/'
    | '/parts/'
    | '/bom/compare/$bomId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuditRoute: typeof AuditRoute
  BomRoute: typeof BomRouteWithChildren
  ChangesRoute: typeof ChangesRouteWithChildren
  CopilotRoute: typeof CopilotRoute
  HelpRoute: typeof HelpRoute
  HubRoute: typeof HubRoute
  InsightsRoute: typeof InsightsRoute
  IntegrationRoute: typeof IntegrationRoute
  KnowledgeRoute: typeof KnowledgeRouteWithChildren
  PartsRoute: typeof PartsRouteWithChildren
  SettingsRoute: typeof SettingsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parts': {
      id: '/parts'
      path: '/parts'
      fullPath: '/parts'
      preLoaderRoute: typeof PartsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/knowledge': {
      id: '/knowledge'
      path: '/knowledge'
      fullPath: '/knowledge'
      preLoaderRoute: typeof KnowledgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integration': {
      id: '/integration'
      path: '/integration'
      fullPath: '/integration'
      preLoaderRoute: typeof IntegrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/insights': {
      id: '/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof InsightsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hub': {
      id: '/hub'
      path: '/hub'
      fullPath: '/hub'
      preLoaderRoute: typeof HubRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/copilot': {
      id: '/copilot'
      path: '/copilot'
      fullPath: '/copilot'
      preLoaderRoute: typeof CopilotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/changes': {
      id: '/changes'
      path: '/changes'
      fullPath: '/changes'
      preLoaderRoute: typeof ChangesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bom': {
      id: '/bom'
      path: '/bom'
      fullPath: '/bom'
      preLoaderRoute: typeof BomRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parts/': {
      id: '/parts/'
      path: '/'
      fullPath: '/parts/'
      preLoaderRoute: typeof PartsIndexRouteImport
      parentRoute: typeof PartsRoute
    }
    '/knowledge/': {
      id: '/knowledge/'
      path: '/'
      fullPath: '/knowledge/'
      preLoaderRoute: typeof KnowledgeIndexRouteImport
      parentRoute: typeof KnowledgeRoute
    }
    '/changes/': {
      id: '/changes/'
      path: '/'
      fullPath: '/changes/'
      preLoaderRoute: typeof ChangesIndexRouteImport
      parentRoute: typeof ChangesRoute
    }
    '/bom/': {
      id: '/bom/'
      path: '/'
      fullPath: '/bom/'
      preLoaderRoute: typeof BomIndexRouteImport
      parentRoute: typeof BomRoute
    }
    '/parts/$partNumber': {
      id: '/parts/$partNumber'
      path: '/$partNumber'
      fullPath: '/parts/$partNumber'
      preLoaderRoute: typeof PartsPartNumberRouteImport
      parentRoute: typeof PartsRoute
    }
    '/knowledge/$kbId': {
      id: '/knowledge/$kbId'
      path: '/$kbId'
      fullPath: '/knowledge/$kbId'
      preLoaderRoute: typeof KnowledgeKbIdRouteImport
      parentRoute: typeof KnowledgeRoute
    }
    '/changes/$changeNumber': {
      id: '/changes/$changeNumber'
      path: '/$changeNumber'
      fullPath: '/changes/$changeNumber'
      preLoaderRoute: typeof ChangesChangeNumberRouteImport
      parentRoute: typeof ChangesRoute
    }
    '/bom/$assemblyPartNumber': {
      id: '/bom/$assemblyPartNumber'
      path: '/$assemblyPartNumber'
      fullPath: '/bom/$assemblyPartNumber'
      preLoaderRoute: typeof BomAssemblyPartNumberRouteImport
      parentRoute: typeof BomRoute
    }
    '/bom/compare/$bomId': {
      id: '/bom/compare/$bomId'
      path: '/compare/$bomId'
      fullPath: '/bom/compare/$bomId'
      preLoaderRoute: typeof BomCompareBomIdRouteImport
      parentRoute: typeof BomRoute
    }
  }
}

interface BomRouteChildren {
  BomAssemblyPartNumberRoute: typeof BomAssemblyPartNumberRoute
  BomIndexRoute: typeof BomIndexRoute
  BomCompareBomIdRoute: typeof BomCompareBomIdRoute
}

const BomRouteChildren: BomRouteChildren = {
  BomAssemblyPartNumberRoute: BomAssemblyPartNumberRoute,
  BomIndexRoute: BomIndexRoute,
  BomCompareBomIdRoute: BomCompareBomIdRoute,
}

const BomRouteWithChildren = BomRoute._addFileChildren(BomRouteChildren)

interface ChangesRouteChildren {
  ChangesChangeNumberRoute: typeof ChangesChangeNumberRoute
  ChangesIndexRoute: typeof ChangesIndexRoute
}

const ChangesRouteChildren: ChangesRouteChildren = {
  ChangesChangeNumberRoute: ChangesChangeNumberRoute,
  ChangesIndexRoute: ChangesIndexRoute,
}

const ChangesRouteWithChildren =
  ChangesRoute._addFileChildren(ChangesRouteChildren)

interface KnowledgeRouteChildren {
  KnowledgeKbIdRoute: typeof KnowledgeKbIdRoute
  KnowledgeIndexRoute: typeof KnowledgeIndexRoute
}

const KnowledgeRouteChildren: KnowledgeRouteChildren = {
  KnowledgeKbIdRoute: KnowledgeKbIdRoute,
  KnowledgeIndexRoute: KnowledgeIndexRoute,
}

const KnowledgeRouteWithChildren = KnowledgeRoute._addFileChildren(
  KnowledgeRouteChildren,
)

interface PartsRouteChildren {
  PartsPartNumberRoute: typeof PartsPartNumberRoute
  PartsIndexRoute: typeof PartsIndexRoute
}

const PartsRouteChildren: PartsRouteChildren = {
  PartsPartNumberRoute: PartsPartNumberRoute,
  PartsIndexRoute: PartsIndexRoute,
}

const PartsRouteWithChildren = PartsRoute._addFileChildren(PartsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuditRoute: AuditRoute,
  BomRoute: BomRouteWithChildren,
  ChangesRoute: ChangesRouteWithChildren,
  CopilotRoute: CopilotRoute,
  HelpRoute: HelpRoute,
  HubRoute: HubRoute,
  InsightsRoute: InsightsRoute,
  IntegrationRoute: IntegrationRoute,
  KnowledgeRoute: KnowledgeRouteWithChildren,
  PartsRoute: PartsRouteWithChildren,
  SettingsRoute: SettingsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
